import React from 'react'
import { Tr, InputNumerText, InputDate } from '../components'

const Inscripcion = ({ setValues, values, handleDate, }) => {
  return (
    <>
                <Tr
                  cols={"3"}
                  gap="2"
                  dist={[1,1,1]}
                  children={[
                    <div className='flex flex-col text-white bg-primarioMira text-center rounded-md p-2'>
                        <label className='text-white font-medium'>Inscripción</label>
                        <p className="text-gray-400">{`Autorizada`}</p>
                          <p>{`Q.${values['InsAutorizada'] || 0}.00`}</p>
                        
                          <p className="text-gray-400">{`Descuento`}</p>
                          <p>{`Q.${values['InsDescuento'] || 0}.00`}</p>
                        
                          <p className="text-gray-400">{`Pagó`}</p>
                          <p>{`Q.${values['InsPaga'] || 0}.00`}</p>
                    </div>,
                    <div className='flex flex-col text-white bg-primarioMira text-center rounded-md p-2'>
                        <label className='text-white font-medium'>Colegiatura</label>
                          <p className="text-gray-400">{`Autorizada`}</p>
                          <p>{`Q.${values['ColAutorizada'] || 0}.00`}</p>
                        
                        
                          <p className="text-gray-400">{`Descuento`}</p>
                          <p>{`Q.${values['ColDescuento'] || 0}.00`}</p>
                        
                        
                          <p className="text-gray-400">{`Paga`}</p>
                          <p>{`Q.${values['ColPaga'] || 0}.00`}</p>
                    </div>,
                    <div className='flex flex-col text-white bg-primarioMira text-center rounded-md p-2'>
                        <label className='text-white font-medium'>Ficha de inscripción</label>
                          <p className="text-gray-400">{`Solicitud`}</p>
                          <p>{`${values['Solicitud']  || ''}`}</p>
                        
                        
                          <p className="text-gray-400">{`Fecha de inscripción`}</p>
                          <p>{`${values['FechaInscripcion'] || ''}`}</p>
                        
                        
                          <p className="text-gray-400">{`Persona inscribió`}</p>
                          <p>{`${values['PersonaInscribio'] || ''}`}</p>
                        
                    </div>,
                    ]}
                    >
                </Tr>
              </>
    
  )
}

export default Inscripcion